import React from 'react';

export const StatusCell = ({ status }: { status: string }) => {
  const statusDisplayMap: Record<string, string> = {
    PENDINGCREATION: 'Pending Creation',
    PENDINGRETRY: 'Pending Retry',
    PENDING: 'Pending',
    SUCCEEDED: 'Succeeded',
    FAILEDCREATION: 'Failed Creation',
    FAILED: 'Failed',
  };

  if (!status) return <></>;

  return (
    <div>
      <span className={`status status--${status.toLowerCase()}`} key={status}>
        {statusDisplayMap[status] || status.toLowerCase()}
      </span>
    </div>
  );
};
